import { createTRPCReact } from '@trpc/react-query';
import type { AppRouter } from '@globalbridge/api/app.router';

export const trpc = createTRPCReact<AppRouter>();
